import * as React from 'react';

import { translate } from '~l10n/client';
import { useAtomValue } from 'jotai';

import { Dialog } from '~shared/components/Dialog';
import {
  CurrentQuizEditorDialog,
  currentQuizEditorDialogAtom,
} from '~teacher/components/QuizEditor/atoms/currentQuizEditorDialogAtom';
import { HideIntercomLauncher } from '~teacher/hook/utils/HideIntercomLauncher';

import { StepAtomProvider } from './atom';
import { QuestionGeneratorContext } from './context/QuestionGeneratorContext';
import { GenerateQuestion } from './GenerateQuestion';

interface Props {
  onClose: () => void;
  refreshQuestions: () => Promise<void>;
}

export function GenerateQuestionDialog({ onClose, refreshQuestions }: Props) {
  const currentQuizEditorDialog = useAtomValue(currentQuizEditorDialogAtom);
  const isOpen =
    currentQuizEditorDialog === CurrentQuizEditorDialog.GenerateQuestions;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      position="right"
      showBackdrop={false}
      open={isOpen}
      onClose={handleClose}
      id={'generate-quiz-dialog'}
      size="medium"
      title={translate('Generate Questions')}
      closeLabel={translate('Close')}
    >
      {() =>
        isOpen ? (
          <StepAtomProvider>
            <QuestionGeneratorContext>
              <GenerateQuestion
                onClose={onClose}
                refreshQuestions={refreshQuestions}
              />
              <HideIntercomLauncher />
            </QuestionGeneratorContext>
          </StepAtomProvider>
        ) : null
      }
    </Dialog>
  );
}
